export const UserTypes = {
    SET_USERTYPES:"SET_USERTYPES",
    ADD_USERTYPES:"ADD_USERTYPES",
    UPDATE_USERTYPES: "UPDATE_USERTYPES",
    DELETE_USERTYPES: "DELETE_USERTYPES",
}


